import Link from "next/link";

export default function Footer() {
  return (
    <>
      <div className="footer-logo footer-info">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <Link href="/" className="navbar-brand d-flex align-items-center ">
                <img
                  src={"/images/home/millance-logo-text.png"}
                  style={{ width: "150px", height: "100%" }}
                  alt="logo"
                  className="img-fluid mx-2"
                />
                <span className="milli"></span>
              </Link>
              <h5 className="px-3 mt-2">
                Maximize Your Trading Potential With Millance LTD!
              </h5>

              <div className="social-links mt-3">
                <a href="#" className="twitter">
                  <i className="bi bi-twitter" />
                </a>
                <a href="" className="facebook">
                  <i className="bi bi-facebook" />
                </a>
                <a href="#" className="instagram">
                  <i className="bi bi-instagram" />
                </a>
                <a href="#" className="linkedin">
                  <i className="bi bi-linkedin" />
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              {/* <div className="social-home">
                <h5 className="mx-5 mb-3">Get in Touch With Us </h5>
                <ul className="d-flex">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61574910490219"
                      target="_blank"
                    >
                      <i className="fab fa-facebook" aria-hidden="true"></i>
                    </a>{" "}
                  </li>

                  <li>
                    <a href="https://x.com/MillanceFX" target="_blank">
                      <i className="twitter">
                        <FaXTwitter />
                      </i>
                    </a>{" "}
                  </li>

                  <li>
                    <a
                      href="https://www.instagram.com/millancefx/"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" aria-hidden="true"></i>
                    </a>{" "}
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/millance-fx-27445735b/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin" aria-hidden="true"></i>
                    </a>{" "}
                  </li>
                  <li>
                    <a
                      className="tiktok "
                      href="https://www.tiktok.com/@millancefx?lang=en-GB"
                      target="_blank"
                    >
                      <FaTiktok />
                    </a>{" "}
                  </li>
                  <li>
                    <a
                      href=" https://www.youtube.com/@MillanceFX"
                      target="_blank"
                    >
                      <i className="fab fa-youtube-play" aria-hidden="true"></i>
                    </a>{" "}
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <footer id="footer" className="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row gy-4">
              {/* <div className="col-lg-2 col-6 footer-links">
                <Link href="/forex-trading-assets">
                  {" "}
                  <h4>Assets</h4>
                </Link>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("forex-currency-trading");
                      }}
                    >
                      Currency
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("commodities");
                      }}
                    >
                      Commodities
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("indices-trading");
                      }}
                    >
                      Indices
                    </span>
                  </li>
               
                </ul>
              </div> */}
              {/* <div className="col-lg-2 col-6 footer-links">
                <h4>Fund</h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("Deposit");
                      }}
                    >
                      Deposits and Withdrawals
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("learn-forex-trading-fees");
                      }}
                    >
                      Trading fees
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("negative-balance-protection");
                      }}
                    >
                      Negative balance
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("forex-brokers-segregated-accounts");
                      }}
                    >
                      Segregate accounts
                    </span>
                  </li>
                </ul>
              </div> */}
              {/* <div className="col-lg-2 col-6 footer-links">
                <h4>Trading Platform</h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("metatrader-5");
                      }}
                    >
                      Metatrader-5
                    </span>
                  </li>



                  <a
                    className="dropdown-item"
                    href="/millance5setup.exe" download
                  >
                    <li>
                      <i className="bi bi-chevron-right" /> MT- Desktop
                    </li>
                  </a>
                  <Link
                    className="dropdown-item"
                    href={'https://download.mql5.com/cdn/mobile/mt5/ios?server=Millance-Server'} target="_blank"                  >

                    <li>
                      <i className="bi bi-chevron-right" /> MT- iPhone
                    </li>
                  </Link>
                  <Link
                    href={'https://download.mql5.com/cdn/mobile/mt5/android?server=Millance-Server'} target="_blank" className="dropdown-item"
                  >
                    <li>
                      <i className="bi bi-chevron-right" /> MT- Android
                    </li>
                  </Link>
                   <li>
                    <a
                      className="dropdown-item"
                      href="https://download.mql5.com/cdn/web/19448/mt5/millance5setup.exe"
                      download
                    >
                      <i className="bi bi-chevron-right" /> MT- Mac
                    </a>
                  </li> 
                </ul>
              </div> */}

              {/* <div className="col-lg-2 col-6 footer-links">
                <h4>For Partners</h4>
                <ul>

                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("introducing-broker-program");
                      }}
                    >
                      {" "}
                      Introducing broker
                    </span>
                  </li>

                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("Whitelabel");
                      }}
                    >
                      {" "}
                      White Label Solutions
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("affiliate");
                      }}
                    >
                      {" "}
                      Affiliate Program
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("products");
                      }}
                    >
                      Products
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("return-and-refund-policy");
                      }}
                    >
                      Privacy
                    </span>
                  </li>
                </ul>
              </div> */}

              {/* <div className="col-lg-2 col-6 footer-links">
                <h4>millance Tools</h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("Pamm");
                      }}
                    >
                      PAMM
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("Mam");
                      }}
                    >
                      MAMM
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("Algo");
                      }}
                    >
                      {" "}
                      Algo Trade
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("Copytrade");
                      }}
                    >
                      {" "}
                      Copy Trade
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("forex-risk-management");
                      }}
                    >
                      {" "}
                      Risk Management
                    </span>
                  </li>
                </ul>
              </div> */}

              <div className="col-lg-2 col-6 footer-links">
                <h4>Client Support</h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <Link href='/about-us'
                      className="handleput"
                    >
                      About us
                    </Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <Link
                      href={'/why-choose-millance'}
                      className="handleput"
                    >
                      {" "}
                      Why choose us
                    </Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />{" "}
                    <Link
                      href={'/contact-us'}
                      className="handleput"
                    >
                      {" "}
                      Contact us
                    </Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right" />
                    <Link
                      href={'/faq'}
                      className="handleput"
                    >
                      FAQ
                    </Link>
                  </li>
                  {/*  <li>
                    <i className="bi bi-chevron-right" />
                    <span
                      className="handleput"
                      onClick={() => {
                        currencypage("legal-documents");
                      }}
                    >
                      Regulations and License
                    </span>
                  </li> */}
                </ul>
              </div>
              {/* <div className="col-lg-2 col-6 footer-links">
                <h4>FOLLOW US</h4>
                <div className="row">
                  <div className="col-6 px-2">
                    <ul>
                      <li>
                        <i className="bi bi-chevron-right" />{" "}
                        <span
                          className="handleput"
                          onClick={() => {
                            currencypage('best-forex-brokers-in-hong-kong');
                          }}
                        >
                          Hong Kong
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />{" "}
                        <span
                          className="handleput"
                          onClick={() => {
                            currencypage("best-forex-brokers-in-china");
                          }}
                        >
                          {" "}
                          China
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />{" "}
                        <span
                          className="handleput"
                          onClick={() => {
                            currencypage("best-forex-brokers-in-uae");
                          }}
                        >
                          {" "}
                          UAE
                        </span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right" />
                        <span
                          className="handleput"
                          onClick={() => {
                            currencypage("best-forex-brokers-in-malaysia");
                          }}
                        >
                          Malaysia
                        </span>
                      </li>
                    </ul>

                  </div>
            
                </div>
              </div> */}
            </div>

            {/* <div className="footer-bottom">
              <ul>
                <li
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  <a href={"/documents/Legal Documents.pdf"}
                    type="" target="_blank"
                    className=""
                    style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                  >
                    Legal Documents
                  </a>
                </li>
                <li>|</li>
                <li
                  onClick={handleShow}
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  Privacy Policy{" "}
                </li>
                <li>|</li>
                <li
                  onClick={handleShow1}
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  Terms and Conditions
                </li>
                <li>|</li>
                <li
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  <a href={"/documents/Arbitrage Millance.pdf"}
                    type="" target="_blank"
                    className=""
                    style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                  >
                    Arbitrage Policy
                  </a>


                </li>
                <li>|</li>
                <li
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  <a href={"/documents/Cookies Policy Millance.pdf"}
                    type="" target="_blank"
                    className=""
                    style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                  >
                    Cookies Policy
                  </a>
                </li>
                <li>|</li>

                <li
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  <a href={"/documents/AML Policy Millance.pdf"}
                    type="" target="blank"
                    className=""
                    style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                  >
                    AML Policy
                  </a>


                </li>
                <li>|</li>
                <li
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  <a href={"/documents/Forex risk disclosure Millance.pdf"}
                    type="" target="_blank"
                    className=""
                    style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                  >
                    Risk Disclosure
                  </a>


                </li>
                <li>|</li>
               
                <li>|</li>
                <li
                  style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                >
                  <a href={"/documents/LPOA MONEY MANAGER AGREEMENT Millance.pdf"}
                    type="" target="_blank"
                    className=""
                    style={{ cursor: "pointer", color: "rgb(0 140 128)" }}
                  >
                    LPOA
                  </a>


                </li>
              </ul>
              <div className="risk-footer">
                <p className="fs-6">
                  <span className="fw-bold">
                    Legal Documents:{" "}
                  </span>
                  Millance Ltd is proud to be regulated by the  Comoros. License Number:<b className="p-1">L15996/ML</b>
                </p>
            
                <p>
                  <span className="fw-bold">Risk Warning : </span>Trading
                  leveraged products like forex and derivatives may not suit all
                  investors due to the high risk of losing money. Before
                  trading, please ensure you fully understand the risks
                  involved, considering your investment objectives and degree of
                  expertise, and get independent advice if necessary. seek
                  independent advice or review our legal documents for further
                  information.
                </p>
                <p>
                  <span className="fw-bold">
                    Risk Disclosure for Restricted Countries:{" "}
                  </span>
                  Regional restrictions Millance Ltd does not provide
                  services to residents of the USA,  Japan, Canada,
                  Haiti, Iran, Suriname, the Democratic People's Republic of
                  Korea, Puerto Rico, Brazil, the Occupied Area of Cyprus,
                  Quebec, Iraq, Syria and Cuba, and Millance Ltd request the
                  clients to check your country jurisdiction.
                </p>
              </div>
            </div> */}
          </div>
        </div>

        {/* <div className="container">
          <div className="copyright">
            Copyright © 2025
            <strong>
              <span className="mx-2">Millance.com</span>
            </strong>
            . All Rights Reserved
            <a href="#top" className="topbtn">
              <BsFillArrowUpCircleFill />
            </a>
           
            <a href="https://wa.link/yldrvr" className="whatsupico" >

              <img
                src={"/images/home/whatsupicon.png"}

                alt="logo"
                className="img-fluid"
              />
            </a>

         
          </div>
          <div className="credits">
           </div>
        </div> */}
      </footer>
      <footer className="main-footer">
        <div className="footer-bottom">
          <div className="auto-container">
            <div className="bottom-top">
              <ul className="list-item">
                <li>
                  <div className="icon-box">
                    <img
                      src={"/images/icon-38.png"}
                      alt=""
                    />
                  </div>
                  <h4>
                    <p>Complaint Registration</p>
                  </h4>
                </li>
                <li>
                  <div className="icon-box">
                    <img
                      src={"/images/icon-39.png"}
                      alt=""
                    />
                  </div>
                  <h4 >
                    <Link href='/terms-condition'>
                      <span className="text-underline">
                        All Terms &amp; Conditions Documents
                      </span>
                    </Link>

                  </h4>
                </li>
                <li>
                  <div className="icon-box">
                    <img
                      src={"/images/icon-40.png"}
                      alt=""
                    />
                  </div>
                  <h4>
                    <p>
                      AML Policy
                    </p>
                  </h4>
                </li>
              </ul>
            </div>

            <div className="row p-2">
              {" "}
              <div className="col-12">
                <p>
                  <strong>Risk Disclosure:</strong> Engaging in Forex trading and other leveraged financial products through Millance LTD carries a high level of risk, which may lead to the loss of your invested funds. It is essential that you only trade with money you can afford to lose and fully understand the potential risks involved. Leveraged products may not be suitable for all investors, and historical performance is not an indicator of future outcomes. Clients are responsible for confirming whether accessing our services is legally permissible based on the regulations in their country of residence. We encourage you to carefully review our complete Risk Disclosure and Legal Documentation for a comprehensive understanding.
                </p>

                <div>
                  {" "}
                  <p>
                    <strong>Regional restrictions:</strong>Millance LTD does not extend its services to individuals residing in the United States, Japan, Russia, British Columbia, Mauritius, Quebec, or any nations identified on the FATF blacklist.
                  </p>
                  <div>
                    <p>
                      <strong>FAQ: </strong>Visit our FAQ section for clear answers to common queries and to gain a better understanding of our platform and services.
                    </p>
                  </div>
                  <p>
                    <strong>Legal: </strong>Millance LTD is authorized and regulated under the International Brokerage and Clearing House License in Comoros, with an official license number of L15996/ML. The company is registered under number 15996. Our commitment to compliance ensures that we operate following strict financial standards and best practices.
                  </p>
                  <p>
                    <strong>Regulatory Disclaimer: </strong>Millance LTD hereby notifies users that its products and services are not made available to individuals or corporate entities that are residents of, incorporated in, or otherwise operating from the United Arab Emirates (UAE) or India.
                    This restriction is implemented in accordance with internal compliance policies and applicable regulatory guidelines governing the provision of financial and trading services.
                  </p>
                </div>
              </div>
            </div>
            <div className="bottom-inner">
              <div className="social-home">
                <h5 className="mx-5 mb-3">FOLLOW US ON</h5>
                <ul className="d-flex">
                  <li>
                    <a
                      href="https://www.facebook.com/people/Millance/61576155035587/"
                      target="_blank"
                    >
                      <i className="fab fa-facebook" aria-hidden="true"></i>
                    </a>{" "}
                  </li>
                  <li>
                    <a href="https://x.com/Millance_Fx" target="_blank">
                      <i className="twitter">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
                        </svg>
                      </i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/millance.fx/"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/107389629/admin/dashboard/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className="tiktok "
                      href="https://www.tiktok.com/@millancefx?lang=en-GB"
                      target="_blank"
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 448 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@Millance_Fx"
                      target="_blank"
                    >
                      <i className="fab fa-youtube" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-logo">
                {/* <figure className="logo"><a href="#">
                              <img src="/images/home/milliance-logo-text.png" alt=""/></a>
                              </figure> */}

                <Link href="/" className="">
                  <img
                    src={"/images/home/millance-logo-text.png"}
                    style={{ width: "150px", height: "100%" }}
                    alt="logo"
                    className="img-fluid mx-2"
                  />
                  <span className="milli"></span>
                </Link>



                <div className="container">
                  <div className="copyright">
                    Copyright © 2026
                    <strong>
                      <span className="mx-2"><Link href={'/'}>Millance.com</Link></span>
                    </strong>
                    . All Rights Reserved
                    <a href="#top" className="topbtn">
                      {/* <BsFillArrowUpCircleFill /> */}
                    </a>
                    {/* <a href="https://wa.link/yldrvr" className="whatsupico">
                      <img
                        src={"/images/home/whatsupicon.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </a> */}
                  </div>
                  <div className="credits"></div>
                </div>
              </div>
              {/* <ul className="footer-nav clearfix">
                <li>
                  <a href="_Onexar Privacy Policy.pdf" target="_blank">
                    Privacy Policy
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
